export default {
  codecanyonNarrowItemCard: '2oVLIOcfTLyg4g0mwqff0w',
  videoHiveNewItemCard: 'MOgF6roKSMWAzp54rwpgMw',
  filesIncludedFilter: 'taqP_usUQIKuSBzJNzzPmQ',
  audioJungleNewPreviewFeatures: 'uglYb1jeQgO6-yXhJyK-6Q'
}
